import { Pipe, PipeTransform } from '@angular/core';
import { COMPANIES } from '@lx/shared/types';
import { capitalizeFirstLetter } from '@lx/shared/utils';

@Pipe({
  name: 'lxCompanyFormattedName',
  standalone: true,
})
export class CompanyFormattedNamePipe implements PipeTransform {
  transform(company: string): string {
    if (company === COMPANIES.ESL) {
      return company.toLocaleUpperCase(navigator.language);
    }
    return capitalizeFirstLetter(company);
  }
}
